<div class="create_popup">
    <div class="modal-body">
        <form [formGroup]="createForm" class="mb-3">
            <div class="product-row">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <div class="row mb-3">
                            <div class="col-sm-4">
                                <b>Category <span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-sm-8" [ngClass]="{disabled: addFromAnotherComponent}">
                                <ng-select formControlName="category" [multiple]="false" appendTo="body"
                                    placeholder="">
                                    <ng-option disabled="">Select</ng-option>
                                    <ng-option *ngFor="let cat of quickCodeCategoryList"
                                        [value]="cat?.id">{{cat?.categoryDescription}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="row  mb-3">
                            <div class="col-sm-4">
                                <b>Name<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" trim="blur" class="form-control" formControlName="name" />
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4">
                                <b>Status <span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-sm-8" [ngClass]="{disabled: addFromAnotherComponent}">
                                <ng-select 
                                [multiple]="false" 
                                formControlName="status" 
                                appendTo="body" 
                                placeholder="Select"
                                [bindValue]="'value'" 
                                [bindLabel]="'label'">
                                <ng-option *ngFor="let option of statusOptions" [value]="option.value">
                                    {{ option.label }}
                                </ng-option>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <!-- <button type="submit" class="btn btn-cancel mr-3" >Cancel</button> -->
    <button type="submit" class="btn btn-primary mr-3" [disabled]="!createForm.valid " (click)="submitForm()">Submit</button>

</div>